



















import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class HomeInformationCard extends Vue {
    /**
     * Title of the card.
     */
    @Prop()
    title: string;

    /**
     * Image of the card.
     */
    @Prop()
    image: object;

    /**
     * Image placeholder to display.
     * This is a Base64 string.
     */
    @Prop({ default: "" })
    imagePlaceholder: string;
}
